import bv115 from "./115";
import bthh from "./bthh";
import bvmathcm from "./bvmathcm";
import bvmedicbd from "./bvmedicbd";
import bvtwct from "./bvtwct";
import choray from "./choray";
import cskh from "./cskh";
import ctchhcm from "./ctchhcm";
import dalieuhcm from "./dalieuhcm";
import dkanphuoc from "./dkanphuoc";
import dkdongnai from "./dkdongnai";
import dkkvangiang from "./dkkvangiang";
import dkvinhlong from "./dkvinhlong";
import leloi from "./leloi";
import medpro from "./medpro";
import momo from "./momo";
import nhidong1 from "./nhidong1";
import noitiettw from "./noitiettw";
import pkdkanhao from "./pkdkanhao";
import pkh from "./pkh";
import trungvuong from "./trungvuong";
import tvmbaclieu from "./tvmbaclieu";
import umc from "./umc";
import vanhanh from "./vanhanh";
import yduoccs2 from "./yduoccs2";

export default {
  bvmedicbd,
  bvmathcm,
  medpro,
  cskh,
  umc,
  trungvuong,
  leloi,
  dkkvangiang,
  nhidong1,
  yduoccs2,
  vanhanh,
  choray,
  "115": bv115,
  bthh,
  dkvinhlong,
  momo,
  dkdongnai,
  noitiettw,
  ctchhcm,
  tvmbaclieu,
  pkdkanhao,
  dkanphuoc,
  pkh,
  dalieuhcm,
  bvtwct
};
